import Stack from '@mui/material/Stack';
import LeadMetric from './LeadMetric';

import config from '../../config/config';
import { useGetLeadsQuery } from '../../redux/services/leadApi';

const LeadMetrics = props => {
  const { metrics, status, filter = {} } = props;
  const leadQuery = useGetLeadsQuery({...filter, has_updates: true});
  const updatedLeadsCount = (leadQuery?.data?.data || []).length;
  if (status === 'ARCHIVED') return null;
  return (
    <Stack direction='row' alignItems='center' padding={2} gap={2}>
      <LeadMetric 
        label={'Updated'}
        tooltip='Leads newly assigned to you and those with unread comments.'
        color={config().colors.secondary}
        precision={0}
        value={updatedLeadsCount} 
      />
      <LeadMetric 
        label={status === 'ACTIVE' ? 'Active' : 'Total'}
        tooltip='Total number of active leads that fit your search filter'
        precision={0}
        value={metrics?.counts?.total} 
      />
      {
        !['NEW', 'CREATED_ACCOUNT'].includes(status) && 
        <LeadMetric
          label='Signed Up'
          tooltip='Total signed up leads divided by total leads'
          numerator={metrics?.counts?.signed_up}
          denominator={metrics?.counts?.total}
          precision={1}
          isPercentage={true} 
        />
      }
      {
        !['NEW', 'CREATED_ACCOUNT', 'COMPLETED_SIGNUP'].includes(status) &&
        <LeadMetric 
          label='Scheduled' 
          tooltip='Total scheduled leads divided by total leads'
          numerator={metrics?.counts?.scheduled} 
          denominator={metrics?.counts?.total}
          precision={1}
          isPercentage={true} 
        />
      }
      {
        !['NEW', 'CREATED_ACCOUNT', 'COMPLETED_SIGNUP', 'SCHEDULED', 'ACTIVE', 'LOST', 'ARCHIVED'].includes(status) &&
        <LeadMetric 
          label='Evaluated' 
          tooltip='Total evaluated leads divided by total leads'
          numerator={metrics?.counts?.evaluated} 
          denominator={metrics?.counts?.total}
          precision={1}
          isPercentage={true} 
        />
      }
      {
        !['NEW', 'ACTIVE', 'NEW', 'CREATED_ACCOUNT', 'COMPLETED_SIGNUP', 'SCHEDULED', 'ARCHIVED', 'EVALUATED', 'LOST'].includes(status) &&
          <LeadMetric 
          label='Lost' 
          tooltip='Total lost leads divided by total leads'
          numerator={metrics?.counts?.lost} 
          denominator={metrics?.counts?.total}
          precision={1}
          isPercentage={true} 
        />
      } 
      {
        !['NEW', 'CREATED_ACCOUNT', 'COMPLETED_SIGNUP'].includes(status) &&
        <LeadMetric
          label='Time to Schedule'
          tooltip='Average time from sign up to scheduling evaluation (in days)'
          precision={1}
          value={
            metrics?.statistics?.mean_time_to_scheduled
            ? metrics?.statistics?.mean_time_to_scheduled
            : 0
          }
        />
      }
      <LeadMetric
        label='Touchpoints'
        tooltip='Average # of touchpoints logged per lead'
        precision={1}
        value={metrics?.statistics?.mean_touchpoints}
      />
    </Stack>
  );
};

export default LeadMetrics;